import { all, takeEvery, put, select, call, delay } from 'redux-saga/effects'

import {
  FEED_EVENT,
  EXCEPTION_EVENT,
  REACTION_CREATED_EVENT,
  REACTION_UPDATED_EVENT,
  NOTIFICATIONS_LOADED_EVENT,
  NOTIFICATIONS_LOADED_MORE_EVENT,
  NOTIFICATIONS_UNREAD_COUNT_LOADED_EVENT,
  NOTIFICATIONS_MARKED_READ,
  STORY_ACTIVITY_LOADED,
  STORY_EVENT,
  STORIES_UNREAD_COUNT_LOADED_EVENT,
  STORIES_MARKED_READ,
  MENTION_CREATED,
  STORY_UPDATED_EVENT,
  PEER_INVITE_ACCEPTED,
} from 'app/constants/sockets'
import {
  getIdentityUserData,
  getIdentityOrganizationTeamOnly,
  getIdentityTeams,
} from 'store/entities/identity/selectors'
import {
  addFeedRecentFromSockets,
  addReactionFromSockets,
  addStoryFromSockets,
  feedStoryActivity,
  storiesMarkedRead,
  storiesUnreadCount,
  updateReactionFromSockets,
  updateStoryFromSockets,
} from 'store/entities/feed/actions'
import {
  notifications,
  reactionCreated,
  notificationsLoadMore,
  notificationsMarkedRead,
  notificationsUnreadCount,
  reactionUpdated,
  mentionCreated,
  peerInviteAccepted,
} from 'store/entities/notifications/actions'

function* handleFeed({ payload }) {
  yield put(addFeedRecentFromSockets(payload))
}

function* handleStory({ payload }) {
  const identity = yield select(getIdentityUserData)
  const isTeamOnly = yield select(getIdentityOrganizationTeamOnly)
  if (isTeamOnly) {
    const userTeams = yield select(getIdentityTeams)
    if (userTeams.toJS().length > 0) {
      const isTeammate = userTeams.some(team => payload.user.teams.includes(team))
      if (!isTeammate) {
        return
      }
    }
  }
  payload.selfStory = identity.get('id') === payload.user.id

  yield put(addStoryFromSockets(payload))
}

function handleException(action) {
  console.log(action)
}

function* handleReactionCreated({ payload }) {
  yield put(addReactionFromSockets(payload))
  const identity = yield select(getIdentityUserData)
  const isEvent = payload.event
  const id = isEvent ? payload.event.user.id : payload.activityUserStory.user.id
  if (identity.get('id') === id) {
    yield put(reactionCreated(payload))
  }
}

function* handleReactionUpdated({ payload }) {
  yield put(updateReactionFromSockets(payload))
  const identity = yield select(getIdentityUserData)
  const isEvent = payload.event
  const id = isEvent ? payload.event.user.id : payload.activityUserStory.user.id
  if (identity.get('id') === id) {
    yield put(reactionUpdated(payload))
  }
}

function* handleMentionCreated({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.userId) {
    yield put(mentionCreated(payload))
  }
}

function* handlePeerInviteAccepted({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.userId) {
    yield put(peerInviteAccepted(payload))
  }
}

function* handleNotificationsLoaded({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield put(notifications.get.success(payload))
  }
}

function* handleMarkNotificationsRead({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield call(delay, 400)
    yield put(notificationsMarkedRead.get.success())
  }
}

function* handleNotificationsLoadedMore({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield put(notificationsLoadMore.get.success(payload))
  }
}

function* handleNotificationsUnreadCountLoaded({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield put(notificationsUnreadCount.get.success(payload))
  }
}

function* handleStoryActivityLoaded({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield put(feedStoryActivity.get.success(payload))
  }
}

function* handleMarkStoriesRead({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield call(delay, 400)
    yield put(storiesMarkedRead.get.success())
  }
}

function* handleStoriesUnreadCountLoaded({ payload }) {
  const identity = yield select(getIdentityUserData)
  if (identity.get('id') === payload.owner.id) {
    yield put(storiesUnreadCount.get.success(payload))
  }
}

function* handleStoryUpdated({ payload }) {
  yield put(updateStoryFromSockets(payload))
}

export default function* socketsFlow() {
  yield all([
    takeEvery(FEED_EVENT, handleFeed),
    takeEvery(STORY_EVENT, handleStory),
    takeEvery(EXCEPTION_EVENT, handleException),
    takeEvery(REACTION_CREATED_EVENT, handleReactionCreated),
    takeEvery(REACTION_UPDATED_EVENT, handleReactionUpdated),
    takeEvery(MENTION_CREATED, handleMentionCreated),
    takeEvery(NOTIFICATIONS_LOADED_EVENT, handleNotificationsLoaded),
    takeEvery(NOTIFICATIONS_LOADED_MORE_EVENT, handleNotificationsLoadedMore),
    takeEvery(NOTIFICATIONS_UNREAD_COUNT_LOADED_EVENT, handleNotificationsUnreadCountLoaded),
    takeEvery(NOTIFICATIONS_MARKED_READ, handleMarkNotificationsRead),
    takeEvery(STORY_ACTIVITY_LOADED, handleStoryActivityLoaded),
    takeEvery(STORIES_UNREAD_COUNT_LOADED_EVENT, handleStoriesUnreadCountLoaded),
    takeEvery(STORIES_MARKED_READ, handleMarkStoriesRead),
    takeEvery(STORY_UPDATED_EVENT, handleStoryUpdated),
    takeEvery(PEER_INVITE_ACCEPTED, handlePeerInviteAccepted),
  ])
}
